<div *ngIf="item.data.hasSubRule" class="locked d-flex flex-column h-100" (click)="helper.unlock(item)">
  <div class="shadow"></div>
  <div class="my-auto w-100 msg">
    <div class="mx-auto d-flex">
      <div class="my-auto">
        <i class="fa fa-times-circle mt-1"></i>
      </div>
      <div class="my-auto ml-2 mr-auto">
        This item has subs or listings custom settings, if you want to continue those settings will not be used for this calculations.
      </div>
    </div>
  </div>
</div>
<div ngbDropdown class="options" container="body" [ngStyle]="{'z-index': item.data.hasSubRule ? 0 : 3}">
  <button ngbDropdownToggle class="btn btn-outline-hover-brand btn-icon btn-sm">
    <i class="flaticon-more kt-label-font-color-1"></i></button>
  <div ngbDropdownMenu>
    <button [disabled]="item.formGroup.value.reorderRuleId || !item.unsavedChanges ? true : null" ngbDropdownItem
      (click)="helper.saveItemSettings(item)">Save settings</button>
    <button *ngIf="item.hasCustomSettings" ngbDropdownItem
      (click)="helper.removeItemSettings(item)">Remove saved settings</button>
    <button [disabled]="item.formGroup.value.reorderRuleId ? true : null" ngbDropdownItem
      (click)="helper.open(null)">Save as rule</button>
    <!-- error code -->
    <!-- <button [disabled]="item.formGroup.value.reorderRuleId ? true : null" ngbDropdownItem
      (click)="helper.open(ruleModal)">Save as rule</button> -->
    <button [disabled]="item.formGroup.value.reorderRuleId != item.data.advancedReorderRuleId ? null : true"
      ngbDropdownItem (click)="helper.setRuleAsItemDefault(item)">Save rule selection</button>
  </div>
</div>